import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid'
import { Card, CardBody, GridLayout, GridLayoutItem } from '@progress/kendo-react-layout'
import { DatePicker } from '@progress/kendo-react-dateinputs'

const data = [
  { usage: 'マンション', rc: '0.25', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '事務所', rc: '0.25', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '学校', rc: '0.68', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '工場・倉庫', rc: '0.48', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '住宅', rc: '0.25', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '病院', rc: '0.71', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '商業施設', rc: '0.25', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: 'ホテル', rc: '0.27', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '大学・専門学校', rc: '0.68', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: 'データセンター', rc: '0.37', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '研究実験施設', rc: '0.83', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '庁舎', rc: '0.72', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '美術館・博物館', rc: '0.67', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '体育館', rc: '0.72', src: '', s: '', pc: '', travis: '', inEdit: true }
]

const dataBugakari = [
  { usage: 'マンション', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '事務所', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '学校', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '工場・倉庫', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '住宅', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '病院', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '商業施設', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: 'ホテル', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '大学・専門学校', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: 'データセンター', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '研究実験施設', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '庁舎', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '美術館・博物館', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true },
  { usage: '体育館', rc: '9.5', src: '', s: '', pc: '', travis: '', inEdit: true }
]

export default function StructureSearchResultList() {
  return (
    <div>
      <Card style={{ margin: 6 }}>
        <CardBody>
          <GridLayout>
            <GridLayoutItem col={1} style={{ textAlign: 'center', marginTop: '3px' }}>
              適用開始日
            </GridLayoutItem>
            <GridLayoutItem col={2}>
              <DatePicker />
            </GridLayoutItem>
          </GridLayout>
        </CardBody>
      </Card>

      <div style={{ display: 'grid', gridTemplateColumns: '50% 50%' }}>
        <div style={{ margin: '0px px 8px 0px' }}>
          <Grid data={data} editField="inEdit">
            <GridToolbar>構造比率（t/m2）</GridToolbar>
            <GridColumn title="用途/構造" field="usage" editable={false} />
            <GridColumn title="RC" field="rc" />
            <GridColumn title="SRC" field="src" />
            <GridColumn title="S" field="s" />
            <GridColumn title="PC" field="pc" />
            <GridColumn title="トラビス" field="travis" />
          </Grid>
        </div>
        <div style={{ gridColumn: 2, margin: '0px 0px 0px 8px' }}>
          <Grid data={dataBugakari} editField="inEdit">
            <GridToolbar>歩掛（t/人日）</GridToolbar>
            <GridColumn title="用途/構造" field="usage" editable={false} />
            <GridColumn title="RC" field="rc" />
            <GridColumn title="SRC" field="src" />
            <GridColumn title="S" field="s" />
            <GridColumn title="PC" field="pc" />
            <GridColumn title="トラビス" field="travis" />
          </Grid>
        </div>
      </div>
    </div>
  )
}
